const theme = {
    // GUEST LIST LOGO

    guestListLogoContiner: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '10px',
        marginBottom: '30px',
    },

    guestListImage: '/assets/photos/ajisaibanner.jpg',

    guestListImageStyle: {
        width: '100%',
        height: '200px',
        objectFit: 'cover',
    },

    description:
        'Offering the freshest food at a reasonable price, for more than 20 years.',

    guestListSubtitleContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginLeft: '30px',
        marginRight: '30px',

        textAlign: 'center',

        fontFamily: 'Noto Sans JP',
        fontStyle: 'italic',
        fontSize: '18px',
        fontWeight: '500',
        color: '#606060',

        marginBottom: '30px',
    },
    guestListGreeting: {
        display: 'none',
    },

    buttonFont: {
        fontFamily: 'Noto Sans JP',
        fontWeight: '400',
        color: '#373737',
    },

    pageTitleFont: {
        color: '#373737',
        fontWeight: '700',
    },
    pageDescriptionFont: {
        color: '#373737',
        fontStyle: 'normal',
    },

    addGuestTextBox: {
        color: '#373737',
        fontFamily: 'Roboto',
        fontWeight: '400',
    },

    // FLOATING BUTTON

    floatingButton: {
        backgroundColor: '#720F0F',
        fontWeight: '500',
    },
    floatingButtonLabel: {
        fontFamily: 'Noto Sans JP',
        fontWeight: '400',
    },

    // HEADER
    headerGuestNameLabel: {
        color: '#373737',
        fontFamily: 'Noto Sans JP',
    },
    headerBackButtonText: {
        fontFamily: 'Noto Sans JP',
        color: '#720F0F',
    },
    headerGuestIcon: {},

    // GUEST HOME OPTIONAL LOGO
    optionalHomeHeaderUrl: '/assets/logos/ajisaioptionalheader.png',
    optionalHomeHeader: {
        display: 'flex',
        justifyContent: 'center',
    },
    optionalHomeHeaderImg: {
        width: '128px',
        height: '128px',
        objectFit: 'cover',
        marginTop: '20px',
        borderRadius: '30px',
    },
    optionalHomeWelcomeContainer: {
        marginTop: '20px',
        marginBottom: '30px',
    },

    // Homepage Greeting
    welcomeGreeting: {
        fontFamily: 'Noto Sans JP',
        fontStyle: 'normal',
        fontWeight: '500',
        color: '#373737',
    },
    welcomeName: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },

    // OPTIONAL GUEST HOME FOOTER
    optionalHomeFooter: {
        paddingTop: '50px',
        paddingBottom: '20px',
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        color: '#B09F9F',
        fontFamily: 'Noto Sans JP',
        fontSize: '16px',
        fontStyle: 'italic',
    },
    optionalHomeFooterText: '8206 Bayview Ave. 905-709-3227',

    itemMultiplierContainer: {
        borderColor: '#720F0F',
    },
    itemMultiplierLeft: {
        borderRightColor: '#720F0F',
        color: '#720F0F',
    },
    itemMultiplierRight: {
        borderLeftColor: '#720F0F',
        color: '#720F0F',
    },
    itemMultiplierText: {
        color: '#720F0F',
    },

    tipLabel: {
        color: '#333',
    },
    tipButton: {
        borderColor: '#720F0F',
        color: '#720F0F',
    },
    tipButtonActive: {
        backgroundColor: '#720F0F',
        color: '#fff',
    },

    // Generic titles and descriptions
    orderTitle: {
        color: '#720F0F',
        fontFamily: 'Noto Sans JP',
    },
    orderDescription: {
        fontFamily: 'Noto Sans JP',
        color: '#720F0F',
    },

    restaurantMenuTitle: {
        fontFamily: 'Noto Sans JP',
        color: '#720F0F',
    },
    restaurantCategoryLabel: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },

    menuCategoryTitle: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },

    menuItemLabel: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },

    itemDetailTitle: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },
    itemDetailPrice: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },
    itemDetailDescription: {
        fontFamily: 'Noto Sans JP',
        color: '#373737',
    },
};

export default theme;
